<template>
    <div v-if="post.operation === 'update'">
        <div v-for="detail in post.details" :key="detail.id">
            <div v-if="detail.field == 'category_id'">
                <div v-if="detail.from === null && detail.to === null">
                    <span>{{ $t(`feed.fields.deleted_category`) }}</span>
                </div>
                <div v-else class="mb-1">
                    <span class="field">{{ $t(`feed.fields.${detail.field}`) }}</span>
                    <div class="mb-2">
                        <span class="field">{{ $t('feed.from') }}: </span>
                        <span class="mr-2">{{
                            detail.from === null ? $t('feed.fields.no_category') : detail.from
                        }}</span>
                        <span class="field">{{ $t('feed.to') }}: </span>
                        <span>{{ detail.to === null ? $t('feed.fields.no_category') : detail.to }}</span>
                    </div>
                </div>
            </div>
            <div v-else-if="detail.field == 'description'">
                <BaseDescription :detail="detail" />
            </div>
        </div>
    </div>
</template>

<script>
import { BaseDescription } from './base'

export default {
    name: 'PostContentValue',
    props: {
        post: {
            type: Object,
            required: true,
        },
    },
    components: {
        BaseDescription,
    },
}
</script>
